import { render, staticRenderFns } from "./UserFormTab.vue?vue&type=template&id=58e72b84&scoped=true"
import script from "./UserFormTab.vue?vue&type=script&lang=js"
export * from "./UserFormTab.vue?vue&type=script&lang=js"
import style0 from "./UserFormTab.vue?vue&type=style&index=0&id=58e72b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e72b84",
  null
  
)

export default component.exports